import type { I18nOptions } from 'vue-i18n';

const formats = {
  shortDate: { day: 'numeric', month: 'numeric', year: 'numeric' },
  shortTime: { hour: 'numeric', minute: 'numeric', hour12: false },
  shortDateTime: {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  },
  mediumDate: { day: 'numeric', month: 'short', year: 'numeric' },
  mediumTime: { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false },
  longDate: { day: 'numeric', month: 'long', year: 'numeric' },
} as const;

export const datetimeFormats: I18nOptions['datetimeFormats'] = {
  'de-DE': formats,
  'en-US': formats,
};
